import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiCheckCircle, FiTarget, FiTrendingUp, FiSmile } from 'react-icons/fi';

const Hero = () => {
  const badges = [
    { icon: FiCheckCircle, text: 'Qualified Team' },
    { icon: FiTarget, text: 'Individual Approach' },
    { icon: FiTrendingUp, text: '100% Success' },
    { icon: FiSmile, text: '100% Satisfaction' },
  ];

  return (
    <section id="home" className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden min-h-screen flex items-center">
      {/* Abstract Glowing Orbs Background */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyan/20 rounded-full blur-[120px] animate-pulse-slow"></div>
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-neon/10 rounded-full blur-[120px] animate-pulse-slow" style={{ animationDelay: '2s' }}></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center max-w-4xl mx-auto">
          <motion.h1 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-4xl sm:text-5xl lg:text-7xl font-heading font-bold text-white leading-tight mb-6"
          >
            Shaping the Future of <br/>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan to-neon">
              Mobility, Energy & Intelligence
            </span>
          </motion.h1>
          
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="mt-4 text-xl text-slate-400 mb-10 font-light"
          >
            Advanced AI, Electrification & Autonomous Systems — Built for Tomorrow
          </motion.p>
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="flex flex-col sm:flex-row gap-4 justify-center"
          >
            <a href="#contact" className="bg-cyan text-navy px-8 py-4 rounded-full font-bold hover:bg-white transition-all duration-300 shadow-[0_0_20px_rgba(0,240,255,0.4)]">
              Get In Touch
            </a>
            <a href="#technology" className="bg-transparent border border-cyan text-cyan px-8 py-4 rounded-full font-bold hover:bg-cyan/10 transition-all duration-300 glow-border">
              Our Services
            </a>
          </motion.div>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-20 grid grid-cols-2 md:grid-cols-4 gap-4 max-w-5xl mx-auto"
        >
          {badges.map((badge, index) => (
            <div key={index} className="bg-charcoal/50 backdrop-blur-sm border border-cyan/10 rounded-2xl p-4 flex flex-col items-center justify-center gap-3 hover:border-cyan/30 transition-colors">
              <div className="bg-navy p-3 rounded-full border border-cyan/20 text-cyan">
                <SafeIcon icon={badge.icon} className="w-6 h-6" />
              </div>
              <span className="font-heading text-sm text-center text-slate-300">{badge.text}</span>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Hero;